import axiosInstance from './axiosInstance'
import config from './config'
import auth from './auth'

export default {
  fetchTerms: () => {
    return axiosInstance.get(`${config.api}/${config.terms}`)
  },
  fetchPrefectures: (areas) => {
    return axiosInstance.get(`${config.api}/${config.prefectures}`)
  },
  fetchAddressesByPrefectures: (prefectures) => {
    return axiosInstance.get(`${config.api}/${config.addresses}?prefecture_id=${prefectures.join(',')}`)
  },
  signup: info => {
    return axiosInstance.post(`${config.api}/${config.customers}`, info, {skipAutoHandle401: true})
  },
  login: info => {
    return axiosInstance.post(`${config.api}/${config.login}`, info, {skipAutoHandle401: true})
  },
  logout: () => {
    return axiosInstance.post(`${config.api}/${config.logout}`,
      {},
      {
        skipAutoHandle401: true,
        headers: {
          Authorization: auth.getAccessToken()
        }
      }
    )
  },
  fetchRequestInfo: () => {
    let accessToken = auth.getAccessToken()
    return axiosInstance.get(`${config.api}/${config.requests}`, {
      headers: {Authorization: accessToken}
    })
  },
  updateRequestInfo: (id, info) => {
    let accessToken = auth.getAccessToken()
    return axiosInstance.put(`${config.api}/${config.requests}/${id}`, info, {
      headers: {Authorization: accessToken}
    })
  },
  searchHospital: keyword => {
    keyword = encodeURIComponent(keyword)
    return axiosInstance.get(`${config.api}/${config.searchHospital}${keyword}`, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  fetchChatrooms: () => {
    return axiosInstance({
      method: 'GET',
      url: `${config.api}/${config.chatrooms}`,
      headers: {
        'Authorization': auth.getAccessToken(),
        'Content-Type': 'application/json'
      }
    })
  },
  fetchMessages: (chatroomId, from) => {
    return axiosInstance({
      method: 'GET',
      url: `${config.api}/${config.messages}?chatroom_id=${chatroomId}&from=${from || ''}`,
      headers: {
        'Authorization': auth.getAccessToken(),
        'Content-Type': 'application/json'
      }
    })
  },
  fetchConsultationOptions: () => {
    let accessToken = auth.getAccessToken()
    return axiosInstance.get(`${config.api}/${config.consultationOptions}`, {
      headers: {Authorization: accessToken}
    })
  },
  uploadFiles: (data) => {
    return axiosInstance.post(`${config.api}/${config.files_presigned}`, data, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  uploadDirectory: (requestId, data) => {
    return axiosInstance.post(`${config.api}/${config.directory_uploads_path({ requestId })}`, data, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  uploadDirectoryFinished: (requestId, directoryUploadId) => {
    return axiosInstance.post(`${config.api}/${config.client_completed_findme_customer_request_directory_upload_path({ requestId, directoryUploadId })}`, {}, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  listDirectoryUploads: (requestId) => {
    return axiosInstance.get(`${config.api}/${config.directory_uploads_path({ requestId })}`, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  uploadFileToS3: (url, data, onUploadProgress) => {
    let config = {
      onUploadProgress: progressEvent => {
        let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
        onUploadProgress(percentCompleted)
      }
    }
    return axiosInstance.post(url, data, config)
  },
  updateFileTargetId: (fileId, targetId) => {
    let data = {target_id: targetId}
    return axiosInstance.put(`${config.api}/${config.files}/${fileId}`, data, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  deleteFile: id => {
    return axiosInstance.delete(`${config.api}/${config.files}/${id}`, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  deleteDirectoryUpload: (requestId, directoryUploadId) => {
    return axiosInstance.delete(`${config.api}/${config.directory_upload_path({ requestId, directoryUploadId })}`, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  fetchCustomerInfo: (id) => {
    return axiosInstance({
      method: 'GET',
      url: `${config.api}/${config.customers}/${id}`,
      headers: {
        'Authorization': auth.getAccessToken(),
        'Content-Type': 'application/json'
      }
    })
  },
  updateCustomerInfo: (id, data) => {
    return axiosInstance.put(`${config.api}/${config.customers}/${id}`, data, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  sendSMS: (id, data) => {
    return axiosInstance.post(`${config.api}/${config.customers}/${id}/send_sms`, data, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  receiveAuthCode: (id, data) => {
    return axiosInstance.post(`${config.api}/${config.customers}/${id}/receive_authentication_code`, data, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  fetchCandidates: () => {
    return axiosInstance ({
      method: 'GET',
      url: `${config.api}/${config.proposals}`,
      headers: {
        'Authorization': auth.getAccessToken(),
        'Content-Type': 'application/json'
      }
    })
  },
  fetchProposal: (id) => {
    return axiosInstance ({
      method: 'GET',
      url: `${config.api}/${config.proposals}/${id}`,
      headers: {
        'Authorization': auth.getAccessToken(),
        'Content-Type': 'application/json'
      }
    })
  },
  getAcceptProposalPrice: (proposalId) => {
    return axiosInstance({
      method: 'GET',
      url: `${config.api}/${config.settings}/payment_amount?payment_type=accept_proposal&proposal_id=${proposalId}`,
      headers: {
        'Authorization': auth.getAccessToken(),
        'Content-Type': 'application/json'
      }
    })
  },
  getShowProfilePrice: (proposalId) => {
    return axiosInstance({
      method: 'GET',
      url: `${config.api}/${config.settings}/payment_amount?payment_type=show_profile&proposal_id=${proposalId}`,
      headers: {
        'Authorization': auth.getAccessToken(),
        'Content-Type': 'application/json'
      }
    })
  },
  acceptProposal: (proposalId, data) => {
    return axiosInstance({
      method: 'POST',
      url: `${config.api}/${config.payments}`,
      headers: {
        'Authorization': auth.getAccessToken(),
        'Content-Type': 'application/json'
      },
      data: {
        payment_type: "accept_proposal",
        proposal_id: proposalId,
        ...data,
      }
    })
  },
  payShowProfile: (proposalId, data) => {
    return axiosInstance({
      method: 'POST',
      url: `${config.api}/${config.payments}`,
      headers: {
        'Authorization': auth.getAccessToken(),
        'Content-Type': 'application/json'
      },
      data: {
        payment_type: "show_profile",
        proposal_id: proposalId,
        ...data,
      }
    })
  },
  fetchPayjpInfo: (token) => {
    return axiosInstance.get(`${config.api}/${config.payjpInfo}${token}`, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  fetchAnnotationPrice: (requestId) => {
    return axiosInstance.get(`${config.api}/${config.annotationPrice}${requestId}`, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  fetchFileData: (id, fileType) => {
    return axiosInstance({
      method: 'GET',
      url: `${config.api}/${config.files}/${id}?file_type=${fileType}`,
      headers: {
        Authorization: auth.getAccessToken()
      },
      responseType: 'arraybuffer'
    })
  },
  fetchFileURL: (id, fileType) => {
    return axiosInstance.get(`${config.api}/${config.files}/${id}/url?file_type=${fileType}`, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  fetchAnnotations: (fileId) => {
    return axiosInstance.get(`${config.api}/${config.annotations}?file_id=${fileId}`, {
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  fetchDoctorInfo: (proposalId) => {
    return axiosInstance({
      method: 'GET',
      url: `${config.api}/${config.doctors}?proposal_id=${proposalId}`,
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  fetchPaymentsInfo: () => {
    return axiosInstance({
      method: 'GET',
      url: `${config.api}/${config.payments}`,
      headers: {
        Authorization: auth.getAccessToken()
      }
    })
  },
  confirmRequest: (uuid) => {
    return axiosInstance({
      method: 'POST',
      url: `${config.api}/${config.requests}/confirm?uuid=${uuid}`
    })
  },
  fetchNotifications: () => {
    return axiosInstance({
      method: 'GET',
      url: `${config.api}/${config.notifications}`,
      headers: {
        Authorization: auth.getAccessToken(),
      }
    })
  },
  resetPassword: (email, password, uuid) => {
    return axiosInstance({
      method: 'POST',
      url: `${config.api}/${config.resetPassword}`,
      data: {
        email,
        password,
        uuid,
      },
      skipAutoHandle401: true
    })
  },
  resetAflacPassword: (email, insurance_policy_no, kana_name, birth_date) => {
    return axiosInstance({
      method: 'POST',
      url: `${config.api}/${config.resetAflacPassword}`,
      data: {
        email,
        insurance_policy_no,
        kana_name,
        birth_date
      },
      skipAutoHandle401: true
    })
  },
  fetchPrices: (requestId) => {
    let qstr = ""
    if (requestId) {
      qstr = `?request_id=${requestId}`
    }
    return axiosInstance({
      method: 'GET',
      url: `${config.api}/${config.prices}${qstr}`,
      headers: {
        'Authorization': auth.getAccessToken(),
        'Content-Type': 'application/json'
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/modules/api.js